/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';

import styles from './styles';
import { makeStyles } from '@mui/styles';
import { Paper, Typography } from '@mui/material';

const useStyles = makeStyles(styles);

export default function CorporativeCard(props) {
  const { className, corporative } = props;
  const classes = useStyles();
  const rootClassName = classNames(classes.root, className);

  return (
    <Paper className={rootClassName}>
      <div className={classes.imageWrapper}>
        <img
          alt={corporative?.name}
          className={classes.image}
          src={
            corporative.logo !== null && corporative.logo !== ''
              ? corporative.logo
              : 'images/logo-metimur.png'
          }
        />
      </div>
      <div className={classes.details}>
        <Typography className={classes.title} variant="h4">
          {corporative?.name}
        </Typography>
        <Typography className={classes.description} variant="body2">
          {corporative?.market_segment}
        </Typography>
      </div>
    </Paper>
  );
}
